module.exports = __webpack_public_path__ + "assets/images/popups/menu_visited.png";